import { httpApi } from '@app/api/http.api'
// import { InvertersToDevice } from '@app/api/inverter.api'

export type CreateDevicePayload = {
  name: string
  type: string
  category: string
  serialNumber: string
  udtNumber?: string
  description?: string
  status?: DeviceStatus
  inverterDeviceConnections: InverterDeviceConnections[]
  alarmDeviceConnections: AlarmDeviceConnections[]
  deviceTemplates: string[]
  serviceUDTDate?: Date
  latitude?: number
  longitude?: number
}

type InverterDeviceConnections = {
  inverterId: string
  dataType: string
  mechanism: string
  index: number | null
}

type AlarmDeviceConnections = {
  alarmId: string
  dataType: string
  index: number | null
  messageId?: number
  bitIndex?: number
}

export type DeviceStatusEnum = 'normal' | 'warning' | 'error'

export type PartOfDataAllDevicesResponse = {
  id: string
  name: string
  type: string
  serialNumber: string
}
export type DeviceStatus = 'NORMAL' | 'BROKEN' | 'NOTUSED' | 'SCRAPPED'

export type DeviceDetailsResponse = {
  id: string
  name: string
  type: string
  category: string | null
  serialNumber: string
  udtNumber?: string
  description?: string
  status?: DeviceStatus
  serviceUDTDate?: Date
  latitude?: number
  longitude?: number
  deviceTemplates: string[]
  inverterDeviceConnections: {
    inverterId: string
    dataType: string
    mechanism: string
    index: number | null
  }[]
  alarmDeviceConnections: {
    alarmId: string
    dataType: string
    index: number | null
    messageId?: number
    id: string
  }[]
  // devicePartMonitorings: {
  //   monitoredElementParamId: string
  //   installationDate: Date | null
  // }[]
}

export type DeviceAlarmsAndErrorsParams = {
  fromDate: string
  toDate: string
  fromTime: string
  toTime: string
  showAll: boolean
  alarms: boolean
  errors: boolean
  confirmed: boolean
  notConfirmed: boolean
  active: boolean
  notActive: boolean
  serialNumber: string
}

export type DeviceAlarmOrError = {
  id: string
  dataType: string
  index: number
  value: string
  deviceId: string
  resolvedDate: Date | null
  confirmedDate: Date | null
  dataSnapshot: string
  confirmedById: string | null
  createdAt: Date
  updatedAt: Date
  device: string
  alarmId?: string
  bitIndex?: number
  inverterId?: string
  inverter?: { name: string }
  alarmDetails?: { messageId: number | null }[]
  inverterErrorDetails?: { value: string | null }[]
}

export type DailyAlarmStatusParams = {
  fromDate: string
  toDate: string
  timezone: string
}

export type DevicePartMonitoring = {
  id: string
  deviceId: string
  monitoredElementParamId: string
  installationDate: Date | null
  askAboutOfferDate: Date | null
  userId: string | null
  createdAt: Date
  updatedAt: Date
  monitoredElementParam: {
    id: string
    dataType: string
    index: number
    warningThreshold: number | null
    alarmThreshold: number | null
    unit: string | null
    usageDirection: string
    partId: string
    part: {
      id: string
      name: string
      category: string
      manufacturer: string | null
      partNumber: string | null
      description: string | null
    }
  }
  user?: {
    id: string
    firstName: string | null
    lastName: string | null
    email: string
  }
}

export type UpdatePartInstallationRequest = {
  deviceId: string
  monitoredElementParamId: string
  installationDate: Date | null
}

export type OfferRequest = {
  id: string
  device: {
    id: string
    name: string
    serialNumber: string
  }
  part: {
    id: string
    name: string
    category: string
  }
  user: {
    id: string
    firstName: string
    lastName: string
    email: string
  }
  usageValue: number
  status: 'normal' | 'warning' | 'alarm'
  askAboutOfferDate: string
  lastPartDataTypeMeasurements: Array<{
    value: string
    type: string
  }>
}

export type DailyAlarmStatusResponse = {
  day: string
  status: 'alarm' | 'error' | 'normal'
}

export type ConfirmAlertRequest = {
  id: string
  type: 'alarm' | 'error'
  confirmedById: string
}

export type AskAboutOfferRequest = {
  devicePartMonitoringId: string
  userId: string
}

export type DeviceTableData = {
  id: string
  name: string
  type: string
  category: string | null
  serialNumber: string
  udtNumber: string
  description: string
  status: DeviceStatus
}

export type UpdateDevicePayload = {
  id: string
  data: CreateDevicePayload
}

export type DeviceResponse = {
  deviceTemplates: string[]
  id: string
  inspections: {
    validityDate: Date
    warningDays: number
    isChecked: boolean
    inspectionDate: Date
  }[]
  latitude: number
  longitude: number
  name: string
  serialNumber: string
  udtNumber: string
}
const DEVICES = 'devices'

// done

export const getAllDevicesTable = (): Promise<DeviceTableData[]> =>
  httpApi.get<DeviceTableData[]>(`${DEVICES}/all-table`).then(({ data }) => data)

export const getDeviceDetails = (id: string): Promise<DeviceDetailsResponse> =>
  httpApi.get<DeviceDetailsResponse>(`${DEVICES}/details/${id}`).then(({ data }) => data)

export const updateDevice = ({ id, data }: UpdateDevicePayload): Promise<DeviceDetailsResponse> =>
  httpApi.put<DeviceDetailsResponse>(`${DEVICES}/update-device/${id}`, data).then(({ data }) => data)

export const createDevice = (createDevicePayload: CreateDevicePayload): Promise<DeviceDetailsResponse> =>
  httpApi.post<DeviceDetailsResponse>(`${DEVICES}/create-device`, createDevicePayload).then(({ data }) => data)

export const deleteDevice = (id: string): Promise<void> =>
  httpApi.delete<void>(`${DEVICES}/${id}`).then(({ data }) => data)

export const getPartOfDataAllDevices = (): Promise<PartOfDataAllDevicesResponse[]> =>
  httpApi.get<PartOfDataAllDevicesResponse[]>(`${DEVICES}/part-devices-data`).then(({ data }) => data)

export const getDevice = (id: string): Promise<DeviceResponse> =>
  httpApi.get<DeviceResponse>(`${DEVICES}/${id}`).then(({ data }) => data)

export const getDeviceAlarmsAndErrors = (
  id: string,
  params: DeviceAlarmsAndErrorsParams,
): Promise<DeviceAlarmOrError[]> =>
  httpApi.post<DeviceAlarmOrError[]>(`devices/${id}/alarms-errors`, params).then(({ data }) => data)

export const getServerDate = (): Promise<{ serverDate: string }> =>
  httpApi.get<{ serverDate: string }>(`${DEVICES}/server-date`).then(({ data }) => data)

export const confirmDeviceAlert = async (payload: ConfirmAlertRequest): Promise<any> =>
  httpApi.post('/devices/confirm-alert', payload).then(({ data }) => data)

export const getDailyAlarmStatus = (id: string, params: DailyAlarmStatusParams): Promise<DailyAlarmStatusResponse[]> =>
  httpApi.post<DailyAlarmStatusResponse[]>(`devices/${id}/daily-alarm-status`, params).then(({ data }) => data)

export const getDevicePartMonitorings = (deviceId: string): Promise<DevicePartMonitoring[]> =>
  httpApi.get<DevicePartMonitoring[]>(`/devices/part-monitoring/${deviceId}`).then(({ data }) => data)

export const updatePartInstallation = (payload: UpdatePartInstallationRequest): Promise<DevicePartMonitoring> =>
  httpApi.put<DevicePartMonitoring>('/devices/part-monitoring/update-installation', payload).then(({ data }) => data)

export const askAboutOffer = (payload: AskAboutOfferRequest): Promise<DevicePartMonitoring> =>
  httpApi.put<DevicePartMonitoring>('/devices/part-monitoring/ask-about-offer', payload).then(({ data }) => data)

export const getOfferRequests = (): Promise<OfferRequest[]> =>
  httpApi.get<OfferRequest[]>('/devices/offer-requests').then(({ data }) => data)
